module.exports = __webpack_public_path__ + "img/banner_01.69c68d6.jpg";